import React from 'react';

import './Footer.css';

export default ({ name }) => (
    <footer className="footer" role="contentinfo">
        <p>&copy; {name} {new Date().getFullYear()}</p>
    </footer>
);
